import { componentResolver } from '../../components'
import { PromoView } from '../../components/lazy'
import { resolvePromoPage } from './resolvePromoPage'

export const PromoPage = /*@__PURE__*/ componentResolver(resolvePromoPage, () => <PromoView />)
